<app-header [isStudent]="false"></app-header>
<div class="initial-attachment-container">
  <div class="title-header">Text Compare</div>
  <div *ngIf="getInitialAttachmentSpinner" class="spinner-overlay">
    <mat-progress-spinner class="spinner" mode="indeterminate"></mat-progress-spinner>
    <p class="message">Waiting for File...</p>
  </div>
  <div class="tableTitle" *ngIf="!getInitialAttachmentSpinner">First File:</div>

  <div *ngIf="!getInitialAttachmentSpinner" class="initialAttachment">
    <div class="initialAttachmentCol" style="width: 15%;">
      <div class="initialAttachmentHeader">ATTEMPT</div>
      <div class="initialAttachmentValue">{{initialSubmission?.attempt}}</div>
    </div>  
    <div class="initialAttachmentCol" style="width: 27.5%;">
      <div class="initialAttachmentHeader">FILE NAME</div>
      <div class="initialAttachmentValue">{{initialAttachment?.title}}</div>
    </div>
    <div class="initialAttachmentCol" style="width: 27.5%;">
      <div class="initialAttachmentHeader">TASK NAME</div>
      <div class="initialAttachmentValue">{{initialSubmission?.taskName}}</div>
    </div>
    <div class="initialAttachmentCol" style="width: 15%;">
      <div class="initialAttachmentHeader">SUBMISSION DATE</div>
      <div class="initialAttachmentValue">{{initialAttachment?.modifiedAt | date:'dd MMM y'}}</div>
    </div>
    <div class="initialAttachmentCol" style="width: 15%;">
      <div class="initialAttachmentHeader">SUBMISSION ID</div>
      <div class="initialAttachmentValue">{{initialSubmission?.submissionId}}</div>
    </div>
  </div>
</div>

<div class="resultsContainer">
  <div class="tableTitle" *ngIf="!getInitialAttachmentSpinner">Select Second File:</div>
  <div class="noResults" *ngIf="pagedSubmissionList.length == 0 && !getInitialAttachmentSpinner">No Submissions Found</div>
  <table mat-table matSort (matSortChange)="sortData($event)" matSortActive="dateSubmitted" matSortDirection="desc" multiTemplateDataRows *ngIf="pagedSubmissionList.length > 0" [dataSource]="pagedSubmissionList" class="submissionTable">
    
    <ng-container matColumnDef="attempt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="attempt"> ATTEMPT </th>
      <td mat-cell *matCellDef="let element"> {{element.attempt}} </td>
    </ng-container>
  
    <ng-container matColumnDef="taskName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="taskName"> TASK NAME </th>
      <td mat-cell *matCellDef="let element"> {{element.taskName}} </td>
    </ng-container>
  
    <ng-container matColumnDef="dateSubmitted">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="dateSubmitted"> SUBMISSION DATE </th>
      <td mat-cell *matCellDef="let element"> {{element.dateSubmitted | date:'dd MMM y'}} </td>
    </ng-container>
    
    <ng-container matColumnDef="submissionId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="submissionId"> SUBMISSION ID </th>
      <td mat-cell *matCellDef="let element"> {{element.submissionId}} </td>
    </ng-container>

    <ng-container matColumnDef="expanded">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <mat-icon [ngClass]="{
          rotatedArrow: expandedElement === element,
          normalArrow: expandedElement !== element
        }">keyboard_arrow_down</mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="emptyCol">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element"></td>
    </ng-container>
  
    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" >
        <div class="expanded-row-detail"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="expandedContent">
            <div class="fileItem" *ngFor="let file of element.attachments">{{file.title}}</div>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="similarityButton">
      <td mat-cell *matCellDef="let element">
        <div class="expanded-row-detail"
              [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="expandedContent">
            <div class="fileItem" *ngFor="let file of element.attachments">
              <span *ngIf="!file.excludedType" class="compareButton" (click)="navigateToScan(file.studentId, file.attachmentId)" onkeydown="navigateToScan(file.studentId, file.attachmentId)">COMPARE</span>
              <span *ngIf="file.excludedType" class="excludedType">FILE TYPE NOT SUPPORTED</span>
            </div>
          </div>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
    class="example-element-row"
    [class.example-expanded-row]="expandedElement === row"
    (click)="expandedClick(row)" onkeydown="expandedElement = expandedElement === row ? null : row"></tr>
    <tr mat-row *matRowDef="let row; columns: ['emptyCol', 'expandedDetail', 'similarityButton']" class="example-detail-row"></tr>
  </table>

  <mat-paginator #paginator
    class="paginator"
    (page)="handlePageEvent($event)"
    [length]="length"
    [pageSize]="pageSize"
    [disabled]="disabled"
    [showFirstLastButtons]="showFirstLastButtons"
    [pageSizeOptions]="showPageSizeOptions ? pageSizeOptions : []"
    [hidePageSize]="hidePageSize"
    [pageIndex]="pageIndex"
    aria-label="Select page">
  </mat-paginator>
</div>
